export default "__VITE_PUBLIC_ASSET__83297b13__"